import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Loader from "../Common/Loader";
import DishOfDay from "../Menu/DishOfDay";
import Categories from "../Categories/Categories";
import "./home.css";
import Seo from "../../Seo/Seo";
import { organizationSchema, webSiteSchema, webPageSchema } from "../../Seo/jsonld";
import { getRouteSeo } from "../../Seo/routeSeo";

function Home() {
  const [loader, setLoader] = useState(true);

  const user = useSelector((state) => state.user);
  const contactDetails = useSelector((state) => state.contact);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [loader]);

  if (loader) {
    return <Loader />;
  }
  const seo = getRouteSeo("/");

  return (
    <main>
      <Seo
        jsonLd={[
          organizationSchema({
            email: contactDetails?.contact?.data?.email,
            phone: contactDetails?.contact?.data?.phone,
          }),
          webSiteSchema(),
          webPageSchema({
            title: seo?.title,
            description: seo?.description,
            url: "/",
          }),
        ]}
      />

      <section className="home-hero-section">
        <svg
          className="hero-bg-shape-bottom"
          viewBox="0 0 850 300"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 90C140 25 260 45 400 130C540 215 700 245 850 220V300H0V90Z"
            fill="#E0F2DC"
            fillOpacity="0.85"
          />
        </svg>
        <svg
          className="hero-bg-shape-top d-none"
          viewBox="0 0 520 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0C130 95 280 115 400 55C450 30 490 10 520 0H0Z"
            fill="#FEF7DE"
            fillOpacity="0.9"
          />
        </svg>

        <div className="container">
          <div className="row align-items-center">
            {/* Left Column Content */}
            <div className="col-lg-6 col-md-12 home-hero-content-col">
              <div className="home-hero-eyebrow wow fadeInUp">
                BALANCERET MADPLAN TIL BØRN
              </div>

              <h1 className="home-hero-title wow fadeInUp" data-wow-delay="0.1s">
                <span className="hero-title-orange">Friske måltider</span>
                <span className="hero-title-green">til de små</span>
                <span className="hero-title-underline" />
              </h1>

              <p className="home-hero-description wow fadeInUp" data-wow-delay="0.2s">
                Vi leverer sund og velsmagende mad hver dag.
                Vores kunder – skoler, elever og forældre – er altid velkomne med nye forslag til retter.
                Den gode dialog giver os glade børn og tilfredse kunder.
              </p>

              {/* 4 Feature Badges */}
              <div className="home-hero-features wow fadeInUp" data-wow-delay="0.3s">
                <div className="hero-feature-item">
                  <div className="hero-feature-icon-wrapper">
                    <img
                      src="/assets/img/10-images/icon_leaf.png"
                      alt="Sunde råvarer"
                      className="hero-feature-icon"
                    />
                  </div>
                  <span className="hero-feature-label">
                    Sunde<br />råvarer
                  </span>
                </div>

                <div className="hero-feature-item">
                  <div className="hero-feature-icon-wrapper">
                    <img
                      src="/assets/img/10-images/icon_heart.png"
                      alt="Børnevenlige retter"
                      className="hero-feature-icon"
                    />
                  </div>
                  <span className="hero-feature-label">
                    Børnevenlige<br />retter
                  </span>
                </div>

                <div className="hero-feature-item">
                  <div className="hero-feature-icon-wrapper">
                    <img
                      src="/assets/img/10-images/icon_dialog.png"
                      alt="Udviklet i dialog"
                      className="hero-feature-icon"
                    />
                  </div>
                  <span className="hero-feature-label">
                    Udviklet i<br />dialog
                  </span>
                </div>

                <div className="hero-feature-item">
                  <div className="hero-feature-icon-wrapper">
                    <img
                      src="/assets/img/10-images/icon_smiley.png"
                      alt="Glade børn hver dag"
                      className="hero-feature-icon"
                    />
                  </div>
                  <span className="hero-feature-label">
                    Glade børn<br />hver dag
                  </span>
                </div>
              </div>

              {/* CTA Button */}
              <div className="home-hero-cta wow fadeInUp" data-wow-delay="0.4s">
                <Link
                  className="hero-cta-btn"
                  to={user?.user?.status ? "/menu" : "/signup"}
                >
                  <span>Kom i gang</span>
                  <svg
                    className="hero-cta-arrow"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </Link>
              </div>
              <div className="flex-group play-app row">
                <div className="col-md-6 ">
                  <Link className="btn btn-dark google_ply mb-3 hero-section-qr" target="blank" to={'https://apps.apple.com/dk/app/onlineskolemad/id6741146828?l=da'}>
                    <span className="play_img">
                      <img src="/assets/img/apple-icon.svg" alt="not found" />
                    </span>
                    <div className="download-cont">
                      <span>Download i</span>
                      <p>Appstore</p>
                    </div>
                  </Link>
                  <img className="qr-img" src="/assets/img/qr-ios.png" />
                </div>
                <div className="col-md-6 mt-md-0 mt-4 mb-md-0">
                  <Link className="btn btn-dark google_ply mb-3 hero-section-qr" target="blank" to={'http://play.google.com/store/apps/details?id=com.onlineskolemad&hl=en'}>
                    <span className="play_img">
                      <img src="/assets/img/palystore-icon.svg" alt="not found" />
                    </span>
                    <div className="download-cont">
                      <span>Hent den i</span>
                      <p>Google Play</p>
                    </div>
                  </Link>
                  <img className="qr-img" src="/assets/img/qr-android.png" />
                </div>
              </div>
            </div>

            {/* Right Column Image */}
            <div className="col-lg-6 col-md-12 home-hero-image-col">
              <div className="home-hero-image-wrapper wow fadeInRight" data-wow-delay="0.2s">
                <img
                  src="/assets/img/10-images/girl_photo_seamless.png"
                  alt="Friske måltider til de små"
                  className="hero-girl-photo"
                />
                <img
                  src="/assets/img/img-mobile-bottom.svg"
                  alt=""
                  className="hero-doodle-leaf"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sec-pd rel-z-1">
        <div className="top-bottom-shaps">
          <span className="shap shap-1" />
          <span className="shap shap-2" />
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mmb-20">
              <div className="img-style-1 wow fadeInLeft">
                <img src="/assets/img/childrens-1.png" alt="Barn med frokostbakke fra Onlineskolemad" />
              </div>
            </div>
            <div className="col-md-6">
              <div>
                <div className="title-1 wow fadeInUp" data-wow-delay="0.1s">
                  {/* The home page's single <h1> — outside the carousel, so it
                      is not cloned. Keeps the original `.title-1 h1` styling. */}
                  <h1>Gør Frokosten Lettere</h1>
                  <div className="btm-line-1">
                    <span />
                    <span />
                  </div>
                  <p>
                    Med Samarbejde med skolerne, har vi sammen lavet en system
                    til at levere maden i frikvarteret, hvor vi levere dem i
                    bokse hvor der er varme retter så de holdes varm, og i
                    bakker med kolde retter, vi har en medarbejder der står klar
                    til at hjælpe, skulle der ske problemer med bestillingen
                    eller andet.{" "}
                  </p>
                  {/* <p>
                    malesuada mauris. Sed gravida arcu et velit placerat
                    volutpat. Curabitur non efficitur metus. iquam erat
                    volutpat. Quisque placerat, metus convallis fringilla
                    vehicula, turpis turpis rutrum massa, quis feugiat justo
                    metus a dolor. Aliquam ullamcorper mollis tortor. Ut finibus
                    mentum eros, non blandit dui. Nulla dapibus quam tellus,
                    vestibulum pulvinar nulla vehicula in. Pellentesque magna
                    ex, eleifend sagittis lacus id, fermentum ornare diam.
                    Aenean tempor scelerisque blandit. Cras rhoncus metus ut
                    justo{" "}
                  </p> */}
                </div>
                <Link className="btn btn-1" to={"/about"}>
                  Læs Mere
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Menu section */}
      <Categories />
      {/* Dish of the day Section */}
      <DishOfDay />
      <section className="sec-pd rel-z-1">
        <div className="top-bottom-shaps">
          <span className="shap shap-1" />
          <span className="shap shap-2" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-6 mmb-20">
              <div className="title-1 wow fadeInUp" data-wow-delay="0.2s">
                <h2 className="title-1-h">Hvordan Virker Det</h2>
                <div className="btm-line-1">
                  <span />
                  <span />
                </div>
              </div>
              <div className="how-it-works-sec">
                <div className="hiw-box wow fadeInLeft" data-wow-delay="0.2s">
                  <span className="hiw-num">01</span>
                  <h3 className="hiw-h">Vælg Din Frokost</h3>
                  <p>
                    Ved at vælge hvilken barn/børn der skal have sin mad Kan du
                    vælge en række forskellige retter, om det Vegetar, Vegan,
                    Halal, Varme Retter, Kolde Retter eller andet. Vi har en
                    masse at vælge imellem.{" "}
                  </p>
                </div>
                <div className="hiw-box wow fadeInLeft" data-wow-delay="0.3s">
                  <span className="hiw-num">02</span>
                  <h3 className="hiw-h">Betal For din ordre</h3>
                  <p>
                    Når du har valgt maden, vælger du den dato det skal leveres.
                    Du kan vælge om det skal være den her uge eller næste, du
                    kan sagtens købe fra flere uger af gangen. De varme retter
                    er dog faste dage, hvor man kan bestille.{" "}
                  </p>
                </div>
                <div className="hiw-box wow fadeInLeft" data-wow-delay="0.4s">
                  <span className="hiw-num">03</span>
                  <h3 className="hiw-h">Ordre Gennemført</h3>
                  <p>
                    Så klikker du bare betal, og du bliver viderestillet til
                    ordre siden så du kan se den ordre du har bestilt, og tjekke
                    om alt er som det skal være, hvis der er en fejl så bare
                    rolig du kan stadig slette ordre og genbestille, indtil kl 6
                    om morgen samme dag, Maden bliver leveret til givet dato på
                    skolen, hvor barn/børnene kan hente deres mad.{" "}
                  </p>
                </div>
              </div>
              <div className="flex-group play-app">
                <Link className="btn btn-dark google_ply" target="blank" to={'https://apps.apple.com/dk/app/onlineskolemad/id6741146828?l=da'}>
                  <span className="play_img">
                    <img src="/assets/img/apple-icon.svg" alt="Apple App Store" />
                  </span>
                  <div className="download-cont">
                    <span>Download i</span>
                    <p>Appstore</p>
                  </div>
                </Link>
                <Link className="btn btn-dark google_ply" target="blank" to={'http://play.google.com/store/apps/details?id=com.onlineskolemad&hl=en'}>
                  <span className="play_img">
                    <img src="/assets/img/palystore-icon.svg" alt="Google Play" />
                  </span>
                  <div className="download-cont">
                    <span>Hent den i</span>
                    <p>Google Play</p>
                  </div>
                </Link>
              </div>
            </div>
            <div className="col-md-6">
              <div className="img-style-2 wow fadeInRight">
                <img src="./assets/img/phone-image-home-page.jpeg" alt="not found" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Slider /> client says to comment this line */}
    </main>
  );
}

export default Home;
